<script lang="ts">
  import { Icon, Title } from '$shared/components';
  import type Timeline from '$shared/models/Timeline';
  import { TimelineIconType } from '$shared/constants/TimelineIconType';

  const DefaultIcon = 'icon-check';

  interface Props {
    list?: Timeline[];
    onevent?: (payload: any) => void;
  }

  let { list = [], onevent }: Props = $props();
</script>

<div class="comp-timeline">
  <div class="card-timeline">
    {#each list as data}
      <div class="timeline-item card">
        <div class="processing-timeline">
          <div class={`icon-bg ${data?.iconType}`}>
            <div class="icon"><Icon value={data?.icon || DefaultIcon} /></div>
          </div>
          <div class="vertical-line">{''}</div>
        </div>
        <div class="content">
          <Title name="timeline-title" type="h3">{data?.title}</Title>
          <div class="description">
            {#if data?.desc}
              <div data-cy="timeline-desc" class="description-content">{data?.desc}</div>
            {/if}
            {#if data?.customDesc?.component}
              {@const SvelteComponent = data?.customDesc?.component}
              <div class="custom-comp">
                <SvelteComponent
                  {...data?.customDesc?.props || {}}
                  active={data?.active}
                  {onevent}
                />
              </div>
            {/if}
            {#if data?.subDesc}
              <div data-cy="timeline-info" class="description-content info">{data?.subDesc}</div>
            {/if}
          </div>
        </div>
      </div>
    {:else}
      <div class="empty">No Data Found</div>
    {/each}
  </div>
</div>

<style src="./TimelineView.css">
</style>
